import { useState } from 'react';
import toast from 'react-hot-toast';
import type { Job } from '../types/job';

interface JobPostingHook {
  createJob: (job: Partial<Job>) => Promise<Job | null>;
  loading: boolean;
}

export function useJobPosting(): JobPostingHook {
  const [loading, setLoading] = useState(false);

  const createJob = async (jobData: Partial<Job>): Promise<Job | null> => {
    try {
      setLoading(true);
      
      // Convert salary type to integer for API
      const salaryTypeInt = jobData.salary_type === 'fourchette' ? 1 : 0;
      
      // Calculate the salary field based on type
      const salary = jobData.salary_type === 'fourchette'
        ? Math.floor((Number(jobData.salary_min || 0) + Number(jobData.salary_max || 0)) / 2)
        : Number(jobData.salary_min || 0);

      // Ensure all numeric values are valid integers
      const payload = {
        ...jobData,
        responsibles_id: jobData.responsibles_id ? parseInt(String(jobData.responsibles_id), 10) : null,
        business_id: jobData.business_id ? parseInt(String(jobData.business_id), 10) : null,
        salary: parseInt(String(salary), 10),
        salary_min: parseInt(String(jobData.salary_min || 0), 10),
        salary_max: jobData.salary_type === 'fourchette'
          ? parseInt(String(jobData.salary_max || 0), 10)
          : parseInt(String(jobData.salary_min || 0), 10),
        postal_code: parseInt(String(jobData.postal_code).padStart(5, '0'), 10),
        salary_type: salaryTypeInt,
        active: true,
        promoted: false,
        created_at: new Date().toISOString(),
        pubdate: new Date().toISOString().split('T')[0],
      };

      const response = await fetch('https://x1lc-aku3-stjs.p7.xano.io/api:moW4brDB/job', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(errorData?.message || 'Failed to create job');
      }

      const data = await response.json();
      toast.success('Offre créée avec succès');
      return data;
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Erreur lors de la création de l\'offre';
      console.error('Error creating job:', message);
      toast.error(message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { createJob, loading };
}